export const isUuid = (s: string | number) =>
  !!(
    typeof s === 'string' &&
    s.match(/^[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{12}$/)
  );
